<template>
  <div id="page-content" tabindex="-1">
    <span aria-label="Reschedule Reservation Page" aria-live="polite" role="contentinfo"></span>
    <h2 class="public-h5 font-weight-bold mt-5 mb-5" 
    :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.rescheduleReservationPageHeader }}
    </h2>
    <p class="text-h8 font-weight-bold"
    :class="isRTLLanguage ? 'rtl' : 'normal'">
      {{ siteText.ui.rescheduleReservationPageSubHeader }}
    </p>
    <div v-for="booking in bookings" :key="booking.BookingId" class="pb-4">
      <v-card>
        <v-card-text class="centerContainer"  :class="isRTLLanguage ? 'rtl' : 'normal'">
          <reservation-details
            :booking="booking"
            :footer-text2="siteText.ui.rescheduleMessageText2"
            :isRTL="isRTLLanguage"
          ></reservation-details>
          <div class="text-left">
            <v-layout row wrap>
              <v-flex md3>
                <v-btn
                  class="ma-2 dmv-btn"
                  height="45px"
                  width="290px"
                  @click="rescheduleReservationPageButton(booking)"
                >
                  {{ siteText.ui.rescheduleReservationPageButton }}
                  <!-- <v-icon>mdi-arrow-right</v-icon> -->
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </v-card-text>
      </v-card>
    </div>
    <p></p>
    <v-card v-if="displayReservationNotFound">
      <v-card-text>
        {{ siteText.ui.reservationNotFoundText }}
        <strong> {{ confirmationNumber }} </strong>
      </v-card-text>
      <v-card-text>
        {{ siteText.ui.reservationNotFoundText2 }}
      </v-card-text>
    </v-card>
    <div class="text-left">
      <v-layout row wrap>
        <v-flex md3>
          <v-btn
            v-if="!directNavigation"
       class="ma-2 dmv-btn"
            height="45px"
            width="260px"
            @click="back()"
            ><v-icon>mdi-arrow-left</v-icon>
            {{ siteText.ui.rescheduleBack }}
          </v-btn>
        </v-flex>
      </v-layout>
    </div>
  </div>
</template>

<script>
import ReservationDetails from "@/components/ReservationDetails.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "RescheduleReservationPage",
  components: { ReservationDetails },
  data() {
    return {
      displayReservationNotFound: false,
    };
  },
  methods: {
    ...mapActions("selectedService", {
      numberOfServicesAction: "numberOfServices",
      selectService1: "selectService1",
      selectService2: "selectService2",
    }),
    ...mapActions(["setUserInfo"]),
    ...mapActions(["setReschedule"]),
    ...mapActions(["getExistingBookings", "selectBooking", "dateOfBirth"]),
    nextPage(page) {
      this.$emit("navigateTo", page);
    },
    back() {
      this.$emit("navigateTo", "DataCollectionPage", {
        header: this.siteText.ui.rescheduleReservationHeader,
        subHeader: this.siteText.ui.rescheduleReservationSubHeader,
        subHeader2: this.siteText.ui.rescheduleReservationSubHeader2,
        pageName: "Reschedule Your Reservation",
      });
    },
    rescheduleReservationPageButton(booking) {
      //TODO: Set new appointment data from existing booking data//
      if (booking) {
        this.selectBooking(booking);
        this.dateOfBirth(booking.DateOfBirth);
        this.setUserInfo({
          firstName: booking.FirstName,
          lastName: booking.LastName,
          email: booking.Email,
          phone: booking.CellPhone,
        });
        this.setServiceTypes(booking);
        this.setReschedule(true);
      }
      this.$emit("navigateTo", "SelectLocationCountyPage", {
        pageName: "Select DMV Office Location",
      });
    },
    setServiceTypes(booking) {
      const serviceType1 = this.$store.getters.serviceType(
        booking.ServiceTypeId
      );
      this.selectService1(serviceType1);

      if (booking.ServiceTypeId2) {
        const serviceType2 = this.$store.getters.serviceType(
          booking.ServiceTypeId2
        );
        this.selectService2(serviceType2);
      }
    },
    async initializePage() {
      if (
        this.directNavigation &&
        (!this.bookings || this.bookings.length < 1)
      ) {
        const bookingsFound = await this.getExistingBookings({
          confirmationNumber: this.confirmationNumber,
        });
        this.displayReservationNotFound = !bookingsFound;
        if (bookingsFound) {
          this.selectBooking(this.bookings[0]);
        }
      }
    },
  },
  computed: {
    ...mapGetters(["siteText"]),
    ...mapGetters(["bookings"]),
    ...mapGetters(["directNavigation", "confirmationNumber", "isRTLLanguage"]),
  },
  async mounted() {
    await this.initializePage();
  },
};
</script>
<style scoped>
.centerContainer {
  margin: auto;
  width: 95%;
}
</style>
